/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ResetNotificationSettingsMutationVariables = Types.Exact<{
  input: Types.NotificationInput;
}>;


export type ResetNotificationSettingsMutation = { __typename: 'Mutation', notificationSettingsUpdate: { __typename: 'NotificationSettingsModel', id: string } };


export const ResetNotificationSettingsDocument = gql`
    mutation resetNotificationSettings($input: NotificationInput!) {
  notificationSettingsUpdate(input: $input) {
    id
  }
}
    `;
export type ResetNotificationSettingsMutationFn = ApolloReactCommon.MutationFunction<ResetNotificationSettingsMutation, ResetNotificationSettingsMutationVariables>;

/**
 * __useResetNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useResetNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetNotificationSettingsMutation, { data, loading, error }] = useResetNotificationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetNotificationSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetNotificationSettingsMutation, ResetNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetNotificationSettingsMutation, ResetNotificationSettingsMutationVariables>(ResetNotificationSettingsDocument, options);
      }
export type ResetNotificationSettingsMutationHookResult = ReturnType<typeof useResetNotificationSettingsMutation>;
export type ResetNotificationSettingsMutationResult = ApolloReactCommon.MutationResult<ResetNotificationSettingsMutation>;
export type ResetNotificationSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetNotificationSettingsMutation, ResetNotificationSettingsMutationVariables>;